module.exports = __webpack_public_path__ + "Lato-Semibold.8b4f872c5de199748573.woff2";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Semibold.woff2
// module id = ../../../../../src/assets/fonts/Lato/Lato-Semibold.woff2
// module chunks = styles